import "./App.scss";
import React, { Component } from "react";
import Header from "./sections/Header";
import TopBanner from "./sections/TopBanner";
import About from "./sections/About";
import Tiles from "./sections/Tiles";
import Quiz from "./sections/Quiz";
import StickerPack from "./sections/StickerPack";
import Footer from "./sections/Footer";

import smoothscroll from "smoothscroll-polyfill";

smoothscroll.polyfill();

class App extends Component {
  state = {
    hideMobileMenu: true,
  };

  sectionTopBanner = React.createRef();
  sectionAbout = React.createRef();
  sectionQuiz = React.createRef();
  sectionStickerPack = React.createRef();

  scrollTo = (e, refName) => {
    e.preventDefault();
    var scroll = 0;
    if (refName !== "sectionTopBanner") {
      scroll = this[refName].current.offsetTop - 60;

      if (window.innerWidth < 900) {
        scroll = this[refName].current.offsetTop;
      }
    }

    window.scrollTo({ top: scroll, behavior: "smooth" });

    setTimeout(() => this.toggleMobileMenu(true), 100);
  };

  toggleMobileMenu = (close) => {
    this.setState({ hideMobileMenu: close });
  };

  render() {
    return (
      <div className="chaos-chinchillas">
        <Header
          scrollTo={this.scrollTo}
          toggleMobileMenu={this.toggleMobileMenu}
          hideMobileMenu={this.state.hideMobileMenu}
        />
        <TopBanner refName={this.sectionTopBanner} />
        <About refName={this.sectionAbout} />
        <Tiles />
        <Quiz refName={this.sectionQuiz} />
        <StickerPack refName={this.sectionStickerPack} />
        <Footer />
      </div>
    );
  }
}

export default App;
